import { ErrorViewOption, ErrorViewType } from '@models';

const ERROR_VIEW_OPTIONS: Record<ErrorViewType, ErrorViewOption> = {
  'access-denied': {
    title: 'Access Denied',
    description: 'You do not have permission to load this view.',
    icon: 'forbidden'
  },
  'milestone-viewer': {
    title: 'Milestone data unavailable',
    description: 'No milestone dates are currently available to display.',
    icon: 'database-banned'
  },
  'not-found': {
    title: 'Sorry, the requested page could not be found',
    icon: 'magnifier-x'
  },
  'not-allowed': {
    title: 'Sorry, you don’t have access to this page.',
    icon: 'access-denied'
  },
  'something-went-wrong': {
    title: 'Something went wrong',
    description: "We're sorry — an error has occurred. Please refresh the page or try again.",
    icon: 'warning'
  }
};

export { ERROR_VIEW_OPTIONS };
